import { CustomerListItemViewModel } from "@payping/api";
import { OptionType } from "@payping/web-components/components/Select/sub/types";
import { FormFields } from "./type";

export interface RequestMoneyOptionData extends Omit<OptionType, "key"> {
  key: string;
  value: string;
}

export function selectCustomers(customer: CustomerListItemViewModel): RequestMoneyOptionData {
  const title = customer.phone || customer.email || customer.code;
  const label =
    customer.businessName ||
    ((customer.firstName || customer.lastName) && `${customer.firstName} ${customer.lastName}`) ||
    title;
  return {
    email: customer.email,
    key: String(customer.code),
    label,
    phone: customer.phone,
    title,
    value: customer.code || "",
  };
}

export function optionExists(optionsArr?: FormFields["payerCodeList"], option?: OptionType): boolean {
  return Boolean(optionsArr?.find((p) => p === option?.key));
}
